<template>
  <Modal v-model="value" width="400" class="modal">
    <div class="con">
      <i class="icon-active pre1" />
      <span>{{$t('other.w137')}}</span>
    </div>
    <p>
      {{$t('other.w138')}}
      <span class="span" @click="toDet">{{$t('other.w139')}}</span>。
    </p>
    <div slot="footer">
      <Button size="large" type="primary" @click="value = false">{{$t('btn.b87')}}</Button>
    </div>
  </Modal>
</template>
<script>
/* 删除确认 */
export default {
  data() {
    return {
      value: false,
    };
  },
  methods: {
    toDet() {
      this.$router.push({
        name: "noticeDetail",
        query: { id: "dcc63239665f41f3ab761ad3a1505e2b" },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.modal {
  .con {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  .icon-active {
    margin-right: 10px;
    display: inline-block;
    position: relative;
    width: 14px;
    height: 14px;
    background: url("../../../assets/borrow/pic_info@2x.png") no-repeat;
    background-size: cover;
    background-position: -14px 0;
    &::before {
      display: none;
      content: "";
      position: absolute;
      left: 0px;
      top: -12px;
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-top: 8px solid rgba(255, 255, 255, 1);
      z-index: 5;
    }
    .desc {
      display: none;
      width: 162px;
      padding: 10px 0 15px 10px;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
      border-radius: 4px;
      background: #fff;
      font-style: normal;
      font-size: 14px;
      color: #000000;
      position: absolute;
      left: -25px;
      bottom: 26px;
      z-index: 5;
    }
    &:hover {
      &::before {
        display: block;
      }
      .desc {
        display: block;
      }
    }
  }
  /deep/.ivu-modal-close {
    display: none;
  }
  /deep/ .ivu-modal-footer {
    padding: 0 0 20px;
    text-align: center;
    .ivu-btn {
      height: 40px;
      width: 200px;
      border-radius: 20px;
      font-size: 16px;
      color: #fff;
    }
  }
  .span {
    color: #5e8ffc;
    cursor: pointer;
  }
}
</style>
